import jApi from './jApi';

export default {
  // application services
  getApplicationsList(params) {
    const api = jApi.generateApi();
    return api.get('/application-pages/studio/applications', params)
      .then(res => res.data);
  },
  getApplicationsListTable(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/applications', params)
      .then(res => res);
  },
  getApplicationDetail(applicationId, params) {
    const api = jApi.generateApi();
    return api.get(`/application-pages/applications/${applicationId}`, params)
      .then(res => res.data);
  },
  createApplication(params) {
    const api = jApi.generateApi();
    return api.post('/application-pages/applications', params)
      .then(res => res.data);
  },
  updateApplication(applicationId, params) {
    const api = jApi.generateApi();
    return api.patch(`/application-pages/studio/applications/${applicationId}`, params)
      .then(res => res.data);
  },
  deleteApplication(params) {
    const api = jApi.generateApi();
    return api.delete(`/application-pages/applications/${params}`)
      .then(res => res.data);
  },

  // pages services
  getPagesList(applicationId, params) {
    const api = jApi.generateApi();
    return api.get(`/application-pages/applications/${applicationId}/pages`, params)
      .then(res => res.data);
  },
  createPage(params) {
    const api = jApi.generateApi();
    return api.post('/application-pages/pages', params)
      .then(res => res.data);
  },
  updatePage(params) {
    const data = {
      application_id: params.application_id,
      name: params.name,
      type: params.type,
      icon_id: params.icon_id,
      order: params.order,
      parent_id: params.parent_id,
      show_option: params.show_option,
      type_platform: params.type_platform,
    };

    if (params.parent_id) {
      Object.assign(data, {
        parent_id: params.parent_id,
      });
    }

    const api = jApi.generateApi();
    return api.patch(`/application-pages/studio/pages/${params.page_id || params.id}`, data)
      .then(res => res.data);
  },
  deletePage(params) {
    const api = jApi.generateApi();
    return api.delete(`/application-pages/pages/${params}`)
      .then(res => res.data);
  },

  // group application services
  getGroupApplicationsList(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/group-application', params)
      .then(res => res.data);
  },
  getGroupApplicationsDetail(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/group-application/application', params)
      .then(res => res.data);
  },
  createGroupApplication(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-apps/group-application', params)
      .then(res => res.data);
  },
  updateGroupApplication(groupId, params) {
    const api = jApi.generateApi();
    return api.patch(`/dynamic-apps/group-application/${groupId}`, params)
      .then(res => res.data);
  },
  deleteGroupApplication(params) {
    const api = jApi.generateApi();
    return api.delete(`/dynamic-apps/group-application/${params}`)
      .then(res => res.data);
  },

  // group relation services
  getGroupRelationsList(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/group-application-relation', params)
      .then(res => res.data);
  },
  createGroupRelation(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-apps/group-application-relation', params)
      .then(res => res.data);
  },
  updateGroupRelation(groupId, params) {
    const api = jApi.generateApi();
    return api.patch(`/dynamic-apps/group-application-relation/${groupId}`, params)
      .then(res => res.data);
  },
  deleteGroupRelation(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-apps/group-application/application/delete', params)
      .then(res => res.data);
  },

  // others services
  getListIcons(req) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/icon', { params: req })
      .then(res => res.data);
  },
  getStandaloneList(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/standalone-master', params)
      .then(res => res.data);
  },
  getCompanySetting() {
    const api = jApi.generateApi();
    return api.get('/times/company-setting')
      .then(res => res.data);
  },
  updateCompanySetting(params) {
    const api = jApi.generateApi();
    return api.post('/times/company-setting/update', params)
      .then(res => res.data);
  },

  // payroll services
  getPayrollCompanyConfig() {
    const api = jApi.generateApi();
    return api.get('/payroll/company-config')
      .then(res => res.data);
  },
  updatePayrollCompanyConfig(params) {
    const api = jApi.generateApi();
    return api.post('/payroll/company-config', params)
      .then(res => res.data);
  },

  // Company Setting
  getUserCompanySetting() {
    const api = jApi.generateApi();
    return api.get('/nocode/company/setting').then(res => res.data);
  },
  updateUserCompanySetting(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/company/setting', params).then(res => res.data);
  },

  // Company Setting New
  getUserCompanySettingV2() {
    const api = jApi.generateApi();
    return api.get('/company-settings/studio/get').then(res => res.data);
  },
  updateUserCompanySettingV2(params) {
    const api = jApi.generateApi();
    return api.post('/company-settings/set', params).then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiSetting.js